import { Box, Paper, Typography } from "@mui/material";
import DOMPurify from "dompurify";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";

import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { DocumentoInternoViewMenu } from "../documentoView/DocumentoInternoViewMenu";
import AssinaturaLoginSenha from "./AssinaturaLoginSenha";
import AssinaturaPFX from "./AssinaturaPFX";
import AssinaturaCertificadoA3 from "./AssinaturaCertificadoA3";

export const DocumentoAssinarView = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams(); //idDocumento

  const { processoSelecionado } = useSelector(
    (state: RootState) => state.processoSelecionado
  );

  useEffect(() => {
    if (!processoSelecionado) {
      alert("Nenhum processo selecionado");
      window.location.href = "/processo/lista"; // Ajuste para o seu URL correto
    }
  }, [processoSelecionado]);

  return (
    <Box sx={{ padding: 1 }}>
      <Box p={1}>
        <DocumentoInternoViewMenu documento={id as string} />
      </Box>

      <Paper
        elevation={3}
        sx={{
          padding: 2,
          backgroundColor: "#f5f5f5",
          borderRadius: 2,
          boxShadow: 3,
          overflow: "hidden",
          wordWrap: "break-word",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Box id="conteudo" mt={2}>
          <AssinaturaLoginSenha documento={id as string} />
          <AssinaturaPFX />
          <AssinaturaCertificadoA3 />
        </Box>
      </Paper>
    </Box>
  );
};
